import React, { FC, Fragment, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { List, Typography } from '@mui/material';

import { LeaderboardConfigFragment } from 'api';
import { IFilter } from 'types/app';
import { Desktop, Mobile, MobileSubmenu, SidebarItem, StickySidebar } from 'components';
import * as paths from 'paths';
import { generateLink } from 'Links';

interface IProps {
  configs: LeaderboardConfigFragment[];
}

const LeaderboardSelect: FC<IProps> = ({ configs }) => {
  const { pathname } = useLocation();
  const [expanded, setExpanded] = useState(false);

  const menuItems = configs.map(config => {
    const { id, title } = config;
    const configPath = `${paths.leaderboard}/${id}`;

    return {
      component: generateLink(configPath),
      textNode: title,
      isSelected: pathname === configPath,
    };
  });

  function getMobileTitle() {
    const selectedFilter = menuItems.find(item => item.isSelected);
    return selectedFilter ? selectedFilter.textNode : '';
  }

  function renderLink(filter: IFilter, index: number) {
    const { component, ...rest } = filter;
    return <SidebarItem key={index} link={component} {...rest} />;
  }

  function renderDesktop() {
    return (
      <StickySidebar>
        <List component="nav">{menuItems.map(renderLink)}</List>
      </StickySidebar>
    );
  }

  function renderMobile() {
    return (
      <MobileSubmenu
        expanded={expanded}
        onToggle={isExpanded => setExpanded(isExpanded)}
        selected={<Typography variant="subtitle2">{getMobileTitle()}</Typography>}
      >
        <List component="nav">{menuItems.map(renderLink)}</List>
      </MobileSubmenu>
    );
  }

  return (
    <Fragment>
      <Desktop>{renderDesktop()}</Desktop>
      <Mobile>{renderMobile()}</Mobile>
    </Fragment>
  );
};

export default LeaderboardSelect;
